import { gql } from '@apollo/client';

// Hand-written types: production introspection is disabled, so this additive
// operation is not in src/generated (same approach as template suggestions).
export type FrameioShareVideo = {
  asset_id: string;
  name: string;
  duration_seconds: number;
  width: number | null;
  height: number | null;
  thumbnail_url: string | null;
  canonical_url: string;
};

export type FrameioShareVideos = {
  share_name: string | null;
  truncated: boolean;
  videos: FrameioShareVideo[];
};

export type FrameioShareVideosQuery = { frameioShareVideos: FrameioShareVideos };
export type FrameioShareVideosQueryVariables = { url: string };

export const FRAMEIO_SHARE_VIDEOS = gql`
  query FrameioShareVideos($url: String!) {
    frameioShareVideos(url: $url) {
      share_name
      truncated
      videos {
        asset_id
        name
        duration_seconds
        width
        height
        thumbnail_url
        canonical_url
      }
    }
  }
`;
